import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = new BehaviorSubject<boolean>(false);
  public darkMode$ = this.darkMode.asObservable();

  constructor() {
    // Check if dark mode is already active
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    const savedTheme = localStorage.getItem('darkMode');

    // Initialize dark mode based on saved preference or system preference
    if (savedTheme !== null) {
      this.setDarkMode(savedTheme === 'true');
    } else {
      this.setDarkMode(prefersDark.matches);
    }

    // Listen for changes in system preference
    prefersDark.addEventListener('change', (mediaQuery) => {
      if (localStorage.getItem('darkMode') === null) {
        this.setDarkMode(mediaQuery.matches);
      }
    });
  }

  setDarkMode(isDark: boolean) {
    this.darkMode.next(isDark);

    // Remove both classes first
    document.body.classList.remove('dark', 'light');

    // Add the appropriate class
    if (isDark) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.add('light');
    }

    localStorage.setItem('darkMode', isDark.toString());
  }

  toggleDarkMode() {
    this.setDarkMode(!this.darkMode.value);
  }
}
